module.exports = __webpack_public_path__ + "static/media/step-image-2.21506320.png";